import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import logger from "../../../../util/logger";
import * as _ from "../../../../util/lodash";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { buttonStates } from "../../../../enums";
import { Selectors, Actions } from "./animating-button-duck";

var AnimatingButton = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AnimatingButton, _React$Component);

  function AnimatingButton() {
    return _React$Component.call(this) || this;
  }

  var _proto = AnimatingButton.prototype;

  _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
    this.props.registerButton(this.props.id, this.props.actions);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.deregisterButton(this.props.id);
  };

  _proto.render = function render() {
    logger.error('AnimatingButton only accepts a single child', React.Children.count(this.props.children) !== 1);
    return /*#__PURE__*/React.cloneElement(this.props.children, {
      buttonState: buttonState(this.props)
    });
  };

  return AnimatingButton;
}(React.Component);

var actionShape = {
  start: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  success: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  failure: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
};
AnimatingButton.propTypes = {
  actions: PropTypes.oneOfType([PropTypes.shape(actionShape), PropTypes.arrayOf(PropTypes.shape(actionShape))]).isRequired
};

function buttonState(props) {
  if (props.isAnimating) return buttonStates.LOADING;
  if (props.isSuccess) return buttonStates.SUCCESS;
  if (props.isFailure) return buttonStates.ERROR;
  return buttonStates.DEFAULT;
}

export default connect(function () {
  var id = _.uniqueId('animating-btn');

  var ButtonSelectors = Selectors.makeAnimatingButtonSelectorById(id);
  return function (state) {
    return {
      isAnimating: ButtonSelectors.isAnimating(state),
      isSuccess: ButtonSelectors.isSuccess(state),
      isFailure: ButtonSelectors.isFailure(state),
      id: id
    };
  };
}, function (dispatch) {
  return {
    registerButton: function registerButton(id, actions) {
      dispatch(Actions.registerButton(id, actions));
    },
    deregisterButton: function deregisterButton(id) {
      dispatch(Actions.deregisterButton(id));
    }
  };
})(AnimatingButton);
//# sourceMappingURL=animating-button.js.map